import { utils } from '@ohif/core';

const { sortingCriteria } = utils;

export default {
  sortingCriteria: sortingCriteria.seriesSortCriteria.seriesInfoSortingCriteria,
};
